import { useEffect, useRef } from 'react'
import { useAuth } from '../auth/AuthProvider'
import { recordUsageEvent, startUsageSession } from '../lib/usage'

function keyFromLabel(label: string) {
  return label
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
}

export function UsageBootstrap() {
  const { profile, offlineProfile } = useAuth()
  const lastOperational = useRef('')
  const lastAdmin = useRef('')
  const lastWorkspace = useRef(false)

  useEffect(() => {
    if (!profile?.ativo || offlineProfile || !navigator.onLine) return
    startUsageSession(profile.id).catch(() => undefined)

    let timer = 0
    const inspect = () => {
      window.clearTimeout(timer)
      timer = window.setTimeout(() => {
        const workLabel = document.querySelector<HTMLElement>('.operation-breadcrumb strong')?.textContent?.trim() || ''
        const isHome = Boolean(document.querySelector('.operation-dashboard'))

        if (isHome && !lastWorkspace.current) {
          recordUsageEvent(profile.id, 'workspace_view', 'atendimento-inicio', 'Atendimento - Início').catch(() => undefined)
        }
        lastWorkspace.current = isHome

        if (workLabel) {
          if (workLabel !== lastOperational.current) {
            lastOperational.current = workLabel
            recordUsageEvent(profile.id, 'module_view', keyFromLabel(workLabel), workLabel).catch(() => undefined)
          }
        } else {
          lastOperational.current = ''
        }

        const adminLabel = document.querySelector<HTMLElement>('.admin-section-nav button.active strong')?.textContent?.trim() || ''
        if (adminLabel) {
          if (adminLabel !== lastAdmin.current) {
            lastAdmin.current = adminLabel
            recordUsageEvent(profile.id, 'admin_view', `admin-${keyFromLabel(adminLabel)}`, adminLabel).catch(() => undefined)
          }
        } else {
          lastAdmin.current = ''
        }
      }, 60)
    }

    inspect()
    const observer = new MutationObserver(inspect)
    observer.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] })
    return () => {
      observer.disconnect()
      window.clearTimeout(timer)
    }
  }, [profile?.id, profile?.ativo, offlineProfile])

  return null
}
